<template>
  <main>
    <div class="bg-gray-200 py-2">
      <div class="breadcrumbs container mx-auto">
        <nuxt-link :to="localePath('index')" class="breadcrumb  px-2">
          {{ $t('home') }}</nuxt-link
        >
        <nuxt-link :to="localePath('solutions')" class="breadcrumb  px-2">
          {{ $t('OUR_SOLUTIONS') }}</nuxt-link
        >
      </div>
    </div>
    <div
      class="solutions px-4 py-8 container mx-auto flex flex-col md:flex-row justify-between"
    >
      <div
        v-for="solution in solutions"
        :key="solution.slug"
        class="solution items-center flex flex-col md:w-1/5"
      >
        <nuxt-link
          :to="
            localePath({
              name: 'solution-slug',
              params: { slug: solution.slug }
            })
          "
        >
          <img
            :src="'/img/icons/' + solution.slug + '.png'"
            class="self-center solution-icon"
            alt="solution icon"
          />
        </nuxt-link>
        <p class="text-black text-center mt-0 mb-4">
          <nuxt-link
            :to="
              localePath({
                name: 'solution-slug',
                params: { slug: solution.slug }
              })
            "
            >{{ solution.name[lang] }}
          </nuxt-link>
        </p>
      </div>
      <div class="solution items-center flex flex-col md:w-1/5">
        <nuxt-link :to="localePath('solution-automotive-logistics')">
          <img
            class="self-center solution-icon"
            src="/img/icons/automotive-logistics.webp"
            alt="automotive-logistics icon"
            loading="lazy"
          />
        </nuxt-link>
        <p class="text-black text-center mt-0 mb-4">
          <nuxt-link :to="localePath('solution-automotive-logistics')">
            {{ $t('automotive_logistics') }}
          </nuxt-link>
        </p>
      </div>
    </div>

    <Video class="mb-12" />
    <Solutions />
    <div class="px-4 py-32  bg-gray-100">
      <div class="container mx-auto">
        <h3 class="font-bold text-center text-3xl">
          {{ $t('anything_you_need') }}
        </h3>
        <div class="flex mt-20 flex-wrap">
          <div class="text-center px-6 w-full md:w-1/3">
            <img
              class="h-20 mx-auto"
              src="/img/icons/global-presence2.png"
              alt="global-presence image"
            />
            <h4 class="text-black text-xl font-bold my-2">
              {{ $t('GLOBAL_PRESENCE') }}
            </h4>
            <p class="text-gray-600 mb-8  h-8 text-sm">
              {{ $t('global_presence_info') }}
            </p>
            <nuxt-link
              :to="localePath('global-presence')"
              class="mt-4 bg-transparent text-black uppercase border-2 border-black px-8 py-2 hover:bg-black hover:text-white"
              >{{ $t('GLOBAL_PRESENCE') }}</nuxt-link
            >
          </div>
          <div class="text-center px-6 w-full md:w-1/3">
            <img
              class="h-20 mx-auto"
              src="/img/icons/local-information2.png"
              alt="local-information image"
            />
            <h4 class="text-black text-xl font-bold my-2">
              {{ $t('LOCAL_INFORMATION') }}
            </h4>
            <p class="text-gray-600 h-8 mb-8 text-sm">
              {{ $t('local_information_info') }}
            </p>
            <nuxt-link
              :to="localePath('local-information')"
              class="mt-4 bg-transparent text-black uppercase border-2 border-black px-8 py-2 hover:bg-black hover:text-white"
              >{{ $t('LOCAL_INFORMATION') }}</nuxt-link
            >
          </div>
          <div class="text-center px-6 w-full md:w-1/3">
            <img
              class="h-20 mx-auto"
              src="/img/icons/contact2.png"
              alt="contact image"
            />
            <h4 class="text-black text-xl font-bold my-2">
              {{ $t('contact') }}
            </h4>
            <p class="text-gray-600 mb-8 h-8 text-sm">
              {{ $t('contact_info') }}
            </p>
            <nuxt-link
              :to="localePath('global-presence')"
              class="mt-4 bg-transparent text-black uppercase border-2 border-black px-8 py-2 hover:bg-black hover:text-white"
              >{{ $t('contact') }}</nuxt-link
            >
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Solutions from '~/components/Solutions'
import solutions from '~/static/solutions.json'
import Video from '~/components/Video'

export default {
  components: {
    Solutions,
    Video
  },
  data() {
    return {
      solutions
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale
    }
  }
}
</script>

<style scoped>
.solution-icon {
  height: 36px;
  @apply mb-2;
  transition: 0.6s;
}
.solution-icon:hover {
  transform: scale(1.1);
}
.flex-wrap div + div {
  @apply mt-12;
}
@screen md {
  .flex-wrap div + div {
    @apply mt-0;
  }
}
</style>
